import { render, staticRenderFns } from "./duplicateSettings.vue?vue&type=template&id=73b57afa&scoped=true&"
import script from "./duplicateSettings.vue?vue&type=script&lang=js&"
export * from "./duplicateSettings.vue?vue&type=script&lang=js&"
import style0 from "./duplicateSettings.vue?vue&type=style&index=0&id=73b57afa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b57afa",
  null
  
)

export default component.exports